import { get } from "../HttpService";

export class LogService {
  static apiLogs = (queryData = {}, config = {}) => {
    return get(`api-logs`, queryData, config);
  };
}
